function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/ems/serverOrder/${viewName}`)
            modules.default.options.metaInfo = { title }
            resolve(modules)
        }, reject, 'plan')
    }
}

let routes = [
    {
        name: 'serverOrderList',
        path: '/ems/serverOrderList',
        meta: {
            title: '日常服务单'
        }
    },
    {
        name: 'serverOrderDetail',
        path: '/ems/serverOrderDetail',
        meta: {
            title: '日常服务单'
        }
    },
    {
        name: 'serverItemDetail',
        path: '/ems/serverItemDetail',
        meta: {
            title: '日常服务单'
        }
    },
    {
        name: 'serverOrderEditor',
        path: '/ems/serverOrderEditor',
        meta: {
            title: '日常服务单'
        }
    }
]

routes.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/modules/ems/serverOrder.js